module.exports = __webpack_public_path__ + "img/物业icon7.d528b7a9.png";